/* =========================================================
   Sudha Oils — Shopify Product Details Script
   ========================================================= */

(function () {
  'use strict';

  // ---------------- Scroll reveal (IntersectionObserver) ----------------
  const initReveal = () => {
    const revealEls = document.querySelectorAll('.shopify-section-sudha .reveal, .shopify-section-sudha .reveal-stagger');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }
  };

  // ---------------- Product Gallery thumbnails ----------------
  const initGallery = () => {
    const thumbs = document.querySelectorAll('.shopify-section-sudha .pd-thumbs img');
    const mainImg = document.querySelector('.shopify-section-sudha #pd-main-img');
    if (thumbs.length && mainImg) {
      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          thumbs.forEach((x) => x.classList.remove('active'));
          t.classList.add('active');
          const largeSrc = t.getAttribute('data-large-src') || t.getAttribute('src');
          mainImg.src = largeSrc;
        });
      });
    }
  };

  // ---------------- Quantity Selectors ----------------
  const initQuantity = () => {
    const minus = document.querySelector('.shopify-section-sudha .qty-btn-minus');
    const plus = document.querySelector('.shopify-section-sudha .qty-btn-plus');
    const input = document.querySelector('.shopify-section-sudha .qty-input-field');
    
    if (minus && plus && input) {
      // Clear old listeners by cloning
      const newMinus = minus.cloneNode(true);
      const newPlus = plus.cloneNode(true);
      minus.parentNode.replaceChild(newMinus, minus);
      plus.parentNode.replaceChild(newPlus, plus);

      newMinus.addEventListener('click', () => {
        let val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
      newPlus.addEventListener('click', () => {
        let val = parseInt(input.value) || 1;
        if (val < 10) input.value = val + 1;
      });
    }
  };

  // ---------------- Variant Options Switcher ----------------
  const initVariants = () => {
    const opts = document.querySelectorAll('.shopify-section-sudha .variant-option');
    const priceDisplay = document.querySelector('.shopify-section-sudha #pd-price');
    const compareDisplay = document.querySelector('.shopify-section-sudha #pd-compare-price');
    const discountDisplay = document.querySelector('.shopify-section-sudha #pd-discount-badge');
    const stickyPriceDisplay = document.querySelector('.shopify-section-sudha #sticky-price-display');
    const hiddenInput = document.querySelector('.shopify-section-sudha #product-select-id');

    if (opts.length) {
      opts.forEach(opt => {
        opt.addEventListener('click', () => {
          opts.forEach(x => {
            x.classList.remove('active');
            x.style.borderColor = 'var(--color-line)';
          });
          opt.classList.add('active');
          opt.style.borderColor = 'var(--color-accent)';

          // Retrieve attributes
          const variantId = opt.getAttribute('data-variant-id') || opt.getAttribute('data-mock-id');
          const price = opt.getAttribute('data-price');
          const compare = opt.getAttribute('data-compare-price') || opt.getAttribute('data-compare');
          const discount = opt.getAttribute('data-discount') || "12.5%";

          // Set hidden form field
          if (hiddenInput && variantId) {
            hiddenInput.value = variantId;
          }

          // Update display text values
          if (priceDisplay && price) priceDisplay.textContent = price;
          if (compareDisplay && compare) compareDisplay.textContent = compare;
          if (stickyPriceDisplay && price) stickyPriceDisplay.textContent = price;
          if (discountDisplay && discount) discountDisplay.textContent = `Save ${discount}`;
        });
      });
    }
  };

  // ---------------- Collapsible Tabs ----------------
  const initTabs = () => {
    const tabs = document.querySelectorAll('.shopify-section-sudha .tab-item');
    if (tabs.length) {
      tabs.forEach(item => {
        const header = item.querySelector('.tab-header');
        const content = item.querySelector('.tab-content');
        if (header && content) {
          header.addEventListener('click', () => {
            const isOpen = item.classList.contains('open');
            
            tabs.forEach(sib => {
              if (sib !== item) {
                sib.classList.remove('open');
                const sibContent = sib.querySelector('.tab-content');
                if (sibContent) sibContent.style.maxHeight = '0px';
              }
            });

            if (isOpen) {
              item.classList.remove('open');
              content.style.maxHeight = '0px';
            } else {
              item.classList.add('open');
              content.style.maxHeight = content.scrollHeight + 'px';
            }
          });
        }
      });
    }
  };

  // ---------------- Product FAQs Accordions ----------------
  const initFAQ = () => {
    document.querySelectorAll('.shopify-section-sudha .faq-item').forEach((item) => {
      const q = item.querySelector('.faq-q');
      const a = item.querySelector('.faq-a');
      if (!q || !a) return;
      
      const newQ = q.cloneNode(true);
      q.parentNode.replaceChild(newQ, q);

      newQ.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.faq-item.open').forEach((sib) => {
          if (sib !== item) {
            sib.classList.remove('open');
            const sibA = sib.querySelector('.faq-a');
            if (sibA) sibA.style.maxHeight = '0px';
          }
        });
        item.classList.toggle('open', !isOpen);
      });
    });
  };

  // ---------------- Sticky Purchase Bar Scroll trigger ----------------
  const initStickyBuy = () => {
    const stickyBar = document.querySelector('.shopify-section-sudha #sticky-buy-bar');
    const formSubmitBtn = document.querySelector('.shopify-section-sudha .product-buy-form button[type="submit"]');
    const stickySubmitBtn = document.querySelector('.shopify-section-sudha #btn-sticky-buy-submit');
    const actualForm = document.querySelector('.shopify-section-sudha #product-form');

    if (stickyBar && formSubmitBtn) {
      window.addEventListener('scroll', () => {
        const triggerPos = formSubmitBtn.getBoundingClientRect().bottom + window.scrollY;
        if (window.scrollY > triggerPos) {
          stickyBar.classList.add('show');
        } else {
          stickyBar.classList.remove('show');
        }
      }, { passive: true });
    }

    if (stickySubmitBtn && actualForm) {
      stickySubmitBtn.addEventListener('click', () => {
        // Trigger submit of the actual Shopify form
        actualForm.dispatchEvent(new Event('submit', { cancelable: true }));
        // Or directly submit form if not intercepted
        actualForm.submit();
      });
    }
  };

  // ---------------- Reviews filtration simulation ----------------
  const initReviews = () => {
    const pills = document.querySelectorAll('.shopify-section-sudha .filter-pills .pill');
    const cards = document.querySelectorAll('.shopify-section-sudha .reviews-section .t-card');
    if (pills.length) {
      pills.forEach(pill => {
        pill.addEventListener('click', () => {
          pills.forEach(x => x.classList.remove('active'));
          pill.classList.add('active');

          if (cards.length) {
            cards.forEach(card => {
              card.style.opacity = '0.3';
              setTimeout(() => {
                card.style.opacity = '1';
              }, 300);
            });
          }
        });
      });
    }
  };

  const initAll = () => {
    initReveal();
    initGallery();
    initQuantity();
    initVariants();
    initTabs();
    initFAQ();
    initStickyBuy();
    initReviews();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor customizer reload hook
  document.addEventListener('shopify:section:load', function (event) {
    initAll();
  });
})();
